import axios from "axios";

export const api = axios.create({
  baseURL: "https://api.serverlondrisoft.com:8006/",
  headers: {
    "Content-Type": "application/json",
  },
});
